import { useWidgetData } from '../useWidgetData'

import { LockerWidget } from '../../../types/widget/widget'

export const useLockerWidget = () => useWidgetData<LockerWidget>('locker')
